<template>
  <div class="main-div">
    <div class="heading-name">
      <img
        v-if="logo == 'userIcon'"
        height="20"
        width="20"
        src="../../../../assets/userDetails/userIcon.svg"
      />
      <img
        v-else-if="logo == 'thumbsup'"
        height="20"
        width="20"
        src="../../../../assets/userDetails/thumbsup.svg"
      />
      <p class="heading-text">{{ heading }}</p>
    </div>
    <v-divider />

    <div
      :style="{ marginLeft: showProfilePic ? '0px' : '32px' }"
      class="details"
    >
      <div v-if="showProfilePic" class="profile">
        <img src="../../../../assets/userDetails/profiledummy.svg" />
        <div class="copy-div">
          <img src="../../../../assets/userDetails/copyButtton.svg" />
          <p class="link-text">Profile Link</p>
        </div>
      </div>
      <div class="question">
        <p>Total Video Posted</p>
        <p>Like Received</p>
        <p>Comment Received</p>
        <p>Like Activity Count</p>
        <p>Comment Activity Count</p>
      </div>
      <div class="answer">
        <p>{{ data.video_posted_count }}</p>
        <p>{{ data.likes }}</p>
        <p>{{ data.comment_received }}</p>
        <p>{{ data.like_activity_count }}</p>
        <p>{{ data.comment_activity_count }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "insightCard",
  props: {
    showProfilePic: Boolean,
    heading: String,
    logo: String,
    data: null,
  },
};
</script>
<style lang="scss" scoped>
.main-div {
  height: 283px;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  p {
    margin-bottom: 0px;
  }
}
.heading-name {
  height: 52px;
  margin-left: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
}
.details {
  display: flex;
  width: 100%;
  flex-direction: row;
}
.profile {
  display: flex;
  width: 20%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 32px 56px 0px 32px;
}
.heading-text {
  color: #3a3f3a;
  font-size: 16px;
  font-weight: 500;
}
.copy-div {
  display: flex;
  gap: 6px;
  margin-top: 32px;
}
.link-text {
  color: #3190e7;
  font-size: 14px;
}
.question {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 70%;
  margin-top: 32px;
  p {
    color: #797e79;
    margin: 0;
  }
}
.answer {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 30%;
  margin-top: 32px;
  p {
    color: #3a3f3a;
    margin: 0;
  }
}
</style>
